export type ProductOrService = {
  name: string
  description: string
}

export type ValueProposition = {
  title: string
  description: string
}

export type IcpGeography = {
  countries: string[]
  regions: string[]
  cities: string[]
}

// LEGACY shape of a workspace's single ICP. ICPs are their own feature now (features/icps);
// this survives only because the document extractor still proposes one (onboarding uses it
// to prefill the user's first ICP) and the profile still carries the old value for
// workspaces that predate ICPs. The profile API no longer accepts it on save.
export type TargetCustomerProfile = {
  industries: string[]
  companySizes: string[]
  jobTitles: string[]
  geography?: IcpGeography
  buyingSignals?: string[]
}

export type IdentityProfile = {
  companyName?: string
  website?: string
  industry?: string
  companySize?: string
  hqLocation?: string
  oneLiner?: string
  aboutUs?: string
  productsServices?: ProductOrService[]
  valuePropositions?: ValueProposition[]
  // Legacy — read-only, never sent back on save. See TargetCustomerProfile.
  targetCustomerProfile?: TargetCustomerProfile
  differentiators?: string
  competitors?: string[]
}

export type CompanyProfile = {
  id: string
  workspaceId: string
  identity: IdentityProfile | null
  identityCompletedAt: string | null
  // Legacy review stamp of the old single ICP — per-ICP review dates live on each ICP now.
  icpReviewedAt: string | null
  icpReviewedBy: string | null
  createdAt: string
  updatedAt: string
}

export const INDUSTRIES = [
  'SaaS / Software',
  'Financial Services',
  'Healthcare',
  'E-commerce / Retail',
  'Marketing & Advertising',
  'Consulting',
  'Real Estate',
  'Manufacturing',
  'Education',
  'Other',
] as const

// Suggestions only — the Regions field accepts free text.
export const REGIONS = [
  'North America',
  'Latin America',
  'Europe',
  'EMEA',
  'Middle East',
  'Africa',
  'APAC',
  'South Asia',
  'Southeast Asia',
  'Oceania',
] as const

export const COMPANY_SIZES = [
  'Just me',
  '2–10',
  '11–50',
  '51–200',
  '201–500',
  '500+',
] as const
